var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center my-5"},[_c('img',{attrs:{"alt":"Loader","src":require("@/assets/img/util/loader.gif"),"width":"250"}})])
}]

export { render, staticRenderFns }